import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';

const userService = () => {
  const login = async ({
    path,
    dateOfBirth,
    email,
    phone,
  }: {
    path: string;
    dateOfBirth: string;
    email?: string;
    phone?: string;
  }): Promise<any> => {
    return ChiroUpAPI.post('api-noauth', `/login`, {
      body: {
        path,
        email,
        phone,
        dateOfBirth,
      },
    });
  };

  const me = async (path?: string): Promise<any> => {
    if (!path) return null;

    return ChiroUpAPI.get('api', `/me/${path}`, {});
  };

  const survey = async (body: {
    patientId: string;
    surveyId: string;
    perBetter: number;
    timesTreated: number;
    experience: string;
    recommend: number;
  }) => {
    return ChiroUpAPI.post('api-noauth', '/survey', {
      body,
    });
  };

  // Survey-email unsubscribe (linked from review-link + 30-day-survey
  // SES templates). Token is a `cryptoDecode`-able cipher carrying
  // `clinicId|email` — the `/subscription-status` endpoints toggle
  // `Patient.optOutEmail` based on it. Ported to healthcom-backend-schedule
  // (the `api-noauth` client) so the legacy healthcom-backend can be retired.
  const subscriptionStatus = async (token: string): Promise<{ subscribed: boolean }> => {
    return ChiroUpAPI.get('api-noauth', '/subscription-status', {
      queryParams: { token: encodeURIComponent(token) },
    });
  };

  const updateSubscription = async (
    token: string,
    action: 'subscribe' | 'unsubscribe'
  ): Promise<void> => {
    return ChiroUpAPI.put('api-noauth', '/subscription-status', {
      queryParams: { token: encodeURIComponent(token) },
      body: { action },
    });
  };

  return {
    login,
    me,
    survey,
    subscriptionStatus,
    updateSubscription,
  };
};

export default userService();
